import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AssetDetailsComponent } from './components/asset-details/asset-details.component';
import { AssetsComponent } from './components/assets/assets.component';
import { SitesComponent } from './components/sites/sites.component';
import { AssetsDetailsComponent } from './components/assets-details/assets-details.component';
import { LoginComponent } from '@card-software/library';
import { AuthenticationGuard } from './guards/authentication.guard';
import { defaultRouteGuard } from '@card-software/library';
import { MENU_ITEMS } from './app-menu';
const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [AuthenticationGuard, defaultRouteGuard(MENU_ITEMS, 'Asset')],
    component: LoginComponent,
  },
  {
    path: 'asset-details',
    component: AssetDetailsComponent,
    canActivate: [AuthenticationGuard],
    data: {
      breadcrumb: [
        { label: 'Assets', route: '/assets' },
        { label: 'Asset_Detail', awaitCurrent: true },
      ],
    },
  },
  {
    path: 'assets',
    component: AssetsComponent,
    canActivate: [AuthenticationGuard],
    data: { breadcrumb: [{ label: 'Assets' }] },
  },
  {
    path: 'sites',
    redirectTo: '/admin/sites',
    pathMatch: 'full',
  },
  {
    path: 'admin',
    // Componentless parent: children inherit this data, so each child must set its own
    // breadcrumb or it would repeat "Administration" twice.
    data: { breadcrumb: [{ label: 'Administration' }] },
    children: [
      {
        path: 'sites',
        component: SitesComponent,
        canActivate: [AuthenticationGuard],
        data: { breadcrumb: [{ label: 'Sites' }] },
      },
      {
        path: 'assets-details',
        component: AssetsDetailsComponent,
        canActivate: [AuthenticationGuard],
        data: { breadcrumb: [{ label: 'Assets_Details' }] },
      },
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '**',
    redirectTo: '',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
